import ProgressPaidCell from "../SeasonProgress/ProgressPaidCell";
import ProgressFreeCell from "../SeasonProgress/ProgressFreeCell";
import DailyTask from "../Dailys/DailyTask";
import {useEffect} from "react";
import {SoundsService} from "../../../../services/SoundsService";
import {sounds} from "../../../../sounds/sound";

function RenderArenaReward({items, paid, free}: any) {

    const item = items[0];

    useEffect(() => {
        if (item.type === 'free_season_progress' || item.type === 'paid_season_progress') {
            setTimeout(function () {
                SoundsService.playSound(sounds.seasonProgress());
            }, 250)
        }
        if (item.type === 'daily_complete') {
            setTimeout(function () {
                SoundsService.playSound(sounds.dailyFinish());
            }, 250)
        }
    }, []);

    return <div className={'renderArenaContainer'}>
        {(item.type === 'free_season_progress') ? (
            <div className={'arenaRewardBlock'}>
                <div className={'arenaRewardBlockText'}>Season progress step complete</div>
                <div className={'progressFreeCell'}>
                    <ProgressFreeCell free={free} item={item.data.level}/>
                </div>
            </div>
        ) : (item.type === 'paid_season_progress') ? (
            <div className={'arenaRewardBlock'}>
                <div className={'arenaRewardBlockText'}>Season progress step complete</div>
                <div className={'progressPaidCell'}>
                    <ProgressPaidCell paid={paid} item={item.data.level}/>
                </div>
            </div>
        ) : (item.type === 'season_progress_finish') ? (
            <div className={'arenaRewardBlock'}>
                <div className={'arenaRewardBlockText'}>Season progress complete</div>
                <div className={'arenaRewardTrollSeasonOver'}></div>
            </div>
        ) : (item.type === 'daily_complete') ? (
            <div className={'arenaRewardBlock'}>
                <div className={'arenaRewardBlockText'}>Daily complete</div>
                <DailyTask key={'arenaReward-1'} task={item.data}/>
            </div>
        ) : (
            <div></div>
        )}

    </div>
}

export default RenderArenaReward;